import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { findFilepaths, isLinkInMatches } from '@atlaskit/editor-common/utils';
import { ADFEncoder } from '@atlaskit/renderer/utils';
import { AiMateMarkdownTransformer } from '@atlassian/conversation-assistant-content-transformer';
export var isAdfContent = function isAdfContent(content) {
  /*
  This try-catch is a necessary guard rail against broken content to prevent higher level
  error boundaries from displaying the error and breaking the experience.
  */
  try {
    return typeof content !== 'string' && 'type' in content && content.type === 'doc';
  } catch (_unused) {
    return false;
  }
};
export var appendContent = function appendContent(content, suggestionContent) {
  if (isAdfContent(content)) {
    // Ensure the content is an array of nodes
    var updatedContent = Array.isArray(content.content) ? content.content : [content.content];

    // Append the new paragraph node
    updatedContent.push({
      type: 'paragraph',
      content: [{
        type: 'text',
        text: suggestionContent
      }]
    });

    // Return the updated DocNode
    return _objectSpread(_objectSpread({}, content), {}, {
      content: updatedContent
    });
  }
  return "".concat(content, "\n\n").concat(suggestionContent);
};
var pluginConfig = {
  linkify: {
    findFilepaths: findFilepaths,
    isLinkInMatches: isLinkInMatches
  },
  smartLinks: {
    regexStorage: global.localStorage
  }
};

// Default schema is https://bitbucket.org/atlassian/adf-schema/src/main/packages/adf-schema/src/schema/default-schema.ts
export var adfEncoder = new ADFEncoder(function (schema) {
  return new AiMateMarkdownTransformer(schema, pluginConfig, false);
});
var streamingAdfEncoder = new ADFEncoder(function (schema) {
  return new AiMateMarkdownTransformer(schema, pluginConfig, true);
});
export var encodeAdf = function encodeAdf(content) {
  var streaming = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isAdfContent(content)) {
    return content;
  }
  return streaming ? streamingAdfEncoder.encode(content) : adfEncoder.encode(content);
};